import { render } from "./SalarySlipApproval.vue?vue&type=template&id=0165f382&scoped=true"
import script from "./SalarySlipApproval.vue?vue&type=script&lang=js"
export * from "./SalarySlipApproval.vue?vue&type=script&lang=js"

import "./SalarySlipApproval.vue?vue&type=style&index=0&id=0165f382&lang=css"
import "./SalarySlipApproval.vue?vue&type=style&index=1&id=0165f382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0165f382"]])

export default __exports__